module.exports = __webpack_public_path__ + "img/scepter-on.570fed26.png";